import { useEffect } from 'react';
import './YogoModal.css';

export default function YogoModal({ url, onClose }) {
  // Close on Escape
  useEffect(() => {
    const onKey = e => { if (e.key === 'Escape') onClose(); };
    document.addEventListener('keydown', onKey);
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', onKey);
      document.body.style.overflow = '';
    };
  }, [onClose]);

  return (
    <div className="yogo-backdrop" onClick={onClose}>
      <div className="yogo-modal" onClick={e => e.stopPropagation()}>
        <button className="yogo-close" onClick={onClose} aria-label="Luk">✕</button>
        <iframe
          src={url}
          title="Little-Stars booking"
          className="yogo-frame"
          allow="payment"
        />
      </div>
    </div>
  );
}
